import angular from 'angular';
import addressSelector from './addressSelector';
import './style.scss';

export default angular
  .module('components.addressSelector', [])
  .component('addressSelector', addressSelector).name;
